import React, { useMemo, useState } from "react"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { bindActionCreators } from "redux"

import {
  ACTIVE_MEETING_ACTION,
  COMPANY_TOKEN_TYPE,
  EXTEND_MEETING_LIST,
  EXTEND_MEETING_TIME_LIST,
  MEETING_CANNOT_BE_EDITED,
  MEETING_INFO,
  MODAL_CONFIRM,
  STATUS,
} from "../../../helpers"
import MeetingDetail from "./components/MeetingDetail/"
import AttendeeCheckIn from "./components/AttendeeCheckIn"
import GuestCheckInStatus from "./components/AttendeeCheckIn/GuestCheckInStatus"

import { MeetingInfoStyled, DropdownStyled } from "./styles"
import { BOOKING, MEETING, MODAL, ORDER } from "../../../reduxs"
import { DropDown2, ModalConfirm, ModalInformation } from "../../../components"

import ExtendMeetingModal from "../OrderManager/OrderModalGroup/ExtendMeetingModal"

function getViewerPinCode(bookingDetail, username) {
  const guestPinCode = bookingDetail.guests?.find((guest) => guest.username === username)?.pincode
  const ownerPinCode = bookingDetail.owner?.username === username ? bookingDetail.pinCode : undefined

  return guestPinCode ?? ownerPinCode
}

function MeetingInfo(props) {
  const {
    bookingId,
    history,
    language,
    username,
    bookingDetail,
    colorTheme,
    openExtendMeetingModal,
    apiExtendMeeting,
    modalReducer,
    modalAction,
    apiEndMeeting,
    closeErrorModalStatus,
    setTextSuccess,
    getBookingDetailById,
    companyTokenType,
  } = props

  const viewerPinCode = useMemo(
    () => getViewerPinCode(bookingDetail, username),
    [bookingDetail, username]
  )

  const [timeExtend, setTimeExtend] = useState(EXTEND_MEETING_TIME_LIST[0])
  const [isClickCopy,setIsClickCopy] = useState(false)
  const isDisable =
    bookingDetail.status === STATUS.END_MEETING ||
    bookingDetail.status === STATUS.NOT_YET_TIME_MEETING

  const [timeExtendText, setTimeExtendText] = useState(
    EXTEND_MEETING_LIST[language][0]
  )

  const handleEditBooking = () => {
    const returnTo = encodeURIComponent(history.location.pathname + history.location.search)
    const separator = window.location.search ? '&' : '?'
    history.push(`/booking/${bookingId.bookingId}${window.location.search}${separator}returnTo=${returnTo}`)
  }

  const editMeetingButtonStyle = useMemo(() => {
    return {
      borderColor: colorTheme.MAIN,
      color: colorTheme.MAIN,
    }
  }, [colorTheme])

  const dynamicStyle = bookingDetail.isEditable && bookingDetail.status !== STATUS.END_MEETING
  ? editMeetingButtonStyle
  : { ...editMeetingButtonStyle, cursor: 'not-allowed', opacity: 0.24 }

  const handleExtendMeeting = () => {
    openExtendMeetingModal(true)
  }

  const selectTimeExtend = (item, index) => {
    setTimeExtendText(item)
    setTimeExtend(EXTEND_MEETING_TIME_LIST[index])
  }

  const modal = {
    openModalConfirm: () => {
      modalAction.openModalConfirm()
    },
    closeModalConfirm: () => {
      modalAction.closeModalConfirm()
    },
    closeModalStatus: () => {
      closeErrorModalStatus()
    },
    openModalInformation: () => {
      modalAction.openModalInformation()
    },
    closeModalInformation: () => {
      modalAction.closeModalInformation()
    },
  }

  const handleClickCopy = (meetingLink) => {
    navigator.clipboard.writeText(meetingLink)
    setIsClickCopy(true)

    setTimeout(() => {
      closeToast()
    }, 3000)
  }

  const closeToast = () => {
    setIsClickCopy(false)
  }

  const endMeeting = () => {
    const params = {
      bookingId: parseInt(bookingId.bookingId),
    }
    apiEndMeeting(params, () => {
      getBookingDetailById(bookingId)
    })
    modal.closeModalConfirm()
    setTextSuccess()
  }

  const DropDownTime = () => {
    return (
      <DropdownStyled>
        <section className='content-body'>
          <DropDown2
            colorTheme={colorTheme.MAIN}
            list={EXTEND_MEETING_LIST[language]}
            currentValue={timeExtendText}
            className='number-input notification-list'
            handleClick={(event, item, index) => selectTimeExtend(item, index)}
          />
        </section>
      </DropdownStyled>
    )
  }

  const handleSubmitExtendMeeting = () => {
    const params = {
      extendMinute: timeExtend,
    }

    apiExtendMeeting(bookingId.bookingId, params, () => {
      getBookingDetailById(bookingId)
    })
  }

  const handleOnClickEdit = () => {
    if (!bookingDetail.isEditable) {
      modal.openModalInformation();
      return
    }

    if (bookingDetail.status !==  STATUS.END_MEETING) {
      handleEditBooking();
      return
    }
  };

  return (
    <MeetingInfoStyled colorTheme={colorTheme}>
      <ExtendMeetingModal
        language={language}
        contentExtendModal={DropDownTime()}
        onClickExtend={handleSubmitExtendMeeting}
      />

      {modalReducer.confirm && (
        <ModalConfirm
          language={language}
          header={ACTIVE_MEETING_ACTION.HEADER_END_MEETING[language]}
          contentText={ACTIVE_MEETING_ACTION.CONTENT_END_MEETING[language]}
          nameButtonCancel={ACTIVE_MEETING_ACTION.BUTTON.BACK[language]}
          nameButtonOk={ACTIVE_MEETING_ACTION.BUTTON.YES[language]}
          onClickAction={endMeeting}
          onClickCancel={modal.closeModalConfirm}
          colorTheme={colorTheme.MAIN}
        />
      )}

      {modalReducer.isOpenModalInformation && (
          <ModalInformation
            headerName={MEETING_CANNOT_BE_EDITED.HEADER[language]}
            colorTheme={colorTheme.MAIN}
            descriptionName={companyTokenType === COMPANY_TOKEN_TYPE.GOOGLE ? MEETING_CANNOT_BE_EDITED.DESCRIPTION.GOOGLE[language] : MEETING_CANNOT_BE_EDITED.DESCRIPTION.MICROSOFT[language]}
            buttonName={MODAL_CONFIRM.CLOSE[language]}
            onClick={() => modal.closeModalInformation()}
          />
        )}

      {!isEmpty(bookingDetail) ? (
        <>
          <div className='meeting-info__box__pin-code'>
            <p>{viewerPinCode && `PIN CODE : ${viewerPinCode}`}</p>
          </div>
          <div className='meeting-info__box__detail'>
            <div className='meeting-info__box__detail--top'>
              <GuestCheckInStatus bookingId={bookingDetail.bookingId} />
              <h1 className='meeting-info__box__detail__header'>
                {MEETING_INFO.MEETING_INFO[language]}
              </h1>

              <MeetingDetail
                bookingDetail={bookingDetail}
                colorTheme={colorTheme}
                language={language}
                handleClickCopy={(meetingLink) => handleClickCopy(meetingLink)}
                closeToast={closeToast}
                isClickCopy={isClickCopy}
              />

              <div className='meeting-info__box__actions'>
                <AttendeeCheckIn bookingId={bookingDetail.bookingId} />
                <button
                  style={dynamicStyle}
                  onClick={handleOnClickEdit}
                  className='meeting-info__box__edit-button'
                >
                  {MEETING_INFO.EDIT_MEETING[language]}
                </button>
              </div>
            </div>
            <div className='meeting-info__box__detail--bottom'>
              <button
                className={`meeting-info__box__detail--bottom__end-button ${
                  isDisable ? "disabled" : ""
                } `}
                onClick={modal.openModalConfirm}
                disabled={isDisable}
              >
                {ACTIVE_MEETING_ACTION.END_MEETING[language]}
              </button>
              <button
                className={`meeting-info__box__detail--bottom__extend-button ${
                  isDisable ? "disabled" : ""
                }`}
                onClick={handleExtendMeeting}
                disabled={isDisable}
              >
                {ACTIVE_MEETING_ACTION.EXTEND_TIME[language]}
              </button>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </MeetingInfoStyled>
  )
}

const mapStateToProps = ({
  accountReducer,
  modalReducer,
  settingReducer,
  holidayReducer,
}) => {
  return {
    language: accountReducer.language,
    username: accountReducer.user.username,
    modalReducer,
    settingReducer,
    listHoliday: holidayReducer.listHoliday,
    colorTheme: accountReducer.user.colorThemePalette,
    companyTokenType: accountReducer.profile.companyTokenType,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getBookingDetailById: (params) =>
      dispatch(MEETING.action.getBookingDetailById(params)),
    closeErrorModalStatus: () => dispatch(MODAL.action.closeModalStatus()),
    openExtendMeetingModal: (isOpen) =>
      dispatch(MODAL.action.openExtendMeetingModal(isOpen)),
    setErrorModal: (isOpen, textModal) =>
      dispatch(MODAL.action.setErrorModal(isOpen, textModal)),
    apiExtendMeeting: (id, params, func) =>
      dispatch(BOOKING.action.extendMeeting(id, params, func)),
    apiEndMeeting: (params, func) =>
      dispatch(BOOKING.action.endMeeting(params, func)),
    modalAction: bindActionCreators(MODAL.action, dispatch),
    setTextSuccess: () =>
      dispatch(ORDER.action.setOrderActionText("endMeetingSuccess", "SUCCESS")),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MeetingInfo)
